const ROUTES = {
  LOGIN: "login",
  USER_REGISTER: "user-register",
  COMPANY_REGISTER: "company-register",
  COMPANY: "company",
  PROFILE: "profile",
  COMPETENCE_MAPS: "competency-maps",
  KNOWLEDGE_BLOCKS: "knowledge-blocks",
  TESTING: "testing",
  PERSONAL_TESTING: "personal",
  GROUP_TESTING: "group",
  SKILL: "skill",
  CANDIDATE: "candidate",
  QUESTION: "question",
  VACANCIES: "vacancies",
} as const;

export default ROUTES;
